import React, { useState } from 'react';
import TableGroupsUsers from 'components/TableGroupUsers';
import DialogInviteUser from 'components/DialogInviteUser';
import { TableRow, TableCell, Collapse, Box, Typography, Button } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { useQuery } from 'react-query';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import * as API from 'api';
const Groups = API.Groups();

export default function ListGroupsTableRowGroupUsers({ isExpanded, group }) {
  const [isGroupUserDialogOpen, setIsGroupUserDialogOpen] = useState(false);

  const {
    isLoading,
    data: users,
    refetch,
  } = useQuery(['group', group.id], () => Groups.getUsers(group.id), {
    select: data => data.results,
  });

  const handleUserInvited = async () => {
    await refetch();
    setIsGroupUserDialogOpen(false);
  };

  if (isLoading)
    return (
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <MuiCircularProgress />
        </TableCell>
      </TableRow>
    );

  return (
    <>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            {isExpanded && (
              <Box bgcolor="#f3f3f3" pl="20px">
                <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} padding="10px">
                  <Box>
                    <Typography variant="h6" gutterBottom component="div">
                      Users
                    </Typography>
                  </Box>
                  <Box>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() => setIsGroupUserDialogOpen(true)}>
                      Invite User
                    </Button>
                  </Box>
                </Box>
                <TableGroupsUsers group={group} users={users} refetchUsers={refetch} />
              </Box>
            )}
          </Collapse>
        </TableCell>
      </TableRow>
      <DialogInviteUser
        open={isGroupUserDialogOpen}
        onClose={() => setIsGroupUserDialogOpen(false)}
        onCreated={handleUserInvited}
        group={group}
      />
    </>
  );
}
